var map = {
	"./Track_8_Story_1_Hello Lisa_.mp3": "e735",
	"./s1_1.mp3": "4608",
	"./s1_2.mp3": "552e",
	"./s1_3.mp3": "904e",
	"./s1_4.mp3": "3d14"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fae1";